export const callIfFunction = (fn: any, ...args: any[]) => {
  if (typeof fn === 'function') {
    return fn.call(fn, ...args);
  }
};

export const applyIfFunction = (thisArg: any, fn: any, ...args: any[]) => {
  if (typeof fn === 'function') {
    return fn.apply(thisArg, ...args);
  }
};
